import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "../ui/switch";
import axios, { API, authHeaders, formatError } from "../../lib/api";

const OPTIONS = [
  ["anthropic", "Claude", "Anthropic"],
  ["openai", "ChatGPT", "OpenAI"],
];

export const AiSettings = () => {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/ai`, { headers: authHeaders() }).then((r) => setCfg(r.data)).catch((e) => toast.error(formatError(e)));
  }, []);

  const save = async (next) => {
    try {
      const { data } = await axios.put(`${API}/admin/ai`, { provider: next.provider, enabled: next.enabled }, { headers: authHeaders() });
      setCfg(data);
      toast.success(`Assistant ${data.enabled ? "on" : "off"} · ${data.model}`);
    } catch (e) {
      toast.error(formatError(e));
    }
  };

  if (!cfg) return null;
  return (
    <div data-testid="admin-ai-settings" className="rounded-[24px] border hairline bg-[var(--forest-2)] p-6 sm:p-8">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="font-display text-2xl font-semibold">Buyer chat assistant</p>
          <p className="text-sm text-[var(--sage)]">Answers buyers on the public site using live stock and prices. Limited to 30 messages per visitor per day.</p>
        </div>
        <label className="flex items-center gap-3 text-sm">
          <Switch data-testid="admin-ai-enabled-switch" checked={cfg.enabled} onCheckedChange={(v) => save({ ...cfg, enabled: v })} />
          {cfg.enabled ? "On" : "Off"}
        </label>
      </div>
      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        {OPTIONS.map(([id, name, maker]) => (
          <button
            key={id}
            data-testid={`admin-ai-provider-${id}`}
            onClick={() => save({ ...cfg, provider: id })}
            className={`text-left rounded-2xl border p-5 transition-colors ${cfg.provider === id ? "border-[var(--husk)] bg-[#E8B04B]/10" : "hairline hover:bg-white/5"}`}
          >
            <p className="font-mono text-[11px] uppercase tracking-wider text-[var(--sage)]">{maker}</p>
            <p className="mt-1 font-display text-xl font-semibold">{name}</p>
            <p className="font-mono text-xs text-[var(--sage)]">{cfg.models?.[id]}</p>
            {cfg.provider === id && <p className="mt-3 text-xs text-[var(--husk)]">In use on the site</p>}
          </button>
        ))}
      </div>
    </div>
  );
};
